<template>
  <div v-if="request">
    <app-view-layout :header="request.name">
      <template #toolbarMenu>
        <DkoSingleToolbarMenu />
      </template>
      <template #content>
        <v-row class="mt-2">
          <v-col
            cols="12"
            md="4"
          >
            <DkoDetailsCard :request="request" />
            <DkoChangesCard
              v-if="request.history"
              class="mt-6"
              :history="request.history"
            />
          </v-col>

          <v-col
            cols="12"
            md="8"
          >
            <DkoStatusCard :request="request" />

            <v-row class="mt-2">
              <v-col>
                <ProjectTeamCard
                  :users="request.members"
                  title="Zespół projektowy"
                  empty-state-text="Dyrekcja DKO ustala osoby oceniające merytorykę."
                  :editable="request.teamEditable"
                  @add="openTeam('members')"
                  @delete="removeMember($event, 'members')"
                />
              </v-col>
              <v-col>
                <ProjectTeamCard
                  :users="request.orderers"
                  title="Zespół zlecający"
                  empty-state-text="Brak osób w zespole zlecającym."
                  :editable="request.teamEditable"
                  @add="openTeam('orderers')"
                  @delete="removeMember($event, 'orderers')"
                />
              </v-col>
              <v-col>
                <ProjectTeamCard
                  :users="request.managers"
                  title="Zespół decyzyjny"
                  empty-state-text="Brak osób w zespole decyzyjnym."
                  :editable="request.teamEditable"
                  @add="openTeam('managers')"
                  @delete="removeMember($event, 'managers')"
                />
              </v-col>
            </v-row>

            <DkoDescriptionCard :request="request" />
          </v-col>
        </v-row>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectTeamCard from '@/components/Projects/ProjectTeamCard.vue';
import DkoChangesCard from '@/components/DkoCooperation/DkoChangesCard.vue';
import DkoDescriptionCard from '@/components/DkoCooperation/DkoDescriptionCard.vue';
import DkoDetailsCard from '@/components/DkoCooperation/DkoDetailsCard.vue';
import DkoSingleToolbarMenu from '@/components/DkoCooperation/DkoSingleToolbarMenu.vue';
import DkoStatusCard from '@/components/DkoCooperation/DkoStatusCard.vue';

export default {
  components: {
    AppViewLayout,
    ProjectTeamCard,
    DkoChangesCard,
    DkoDescriptionCard,
    DkoDetailsCard,
    DkoSingleToolbarMenu,
    DkoStatusCard,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...mapState('dkoCooperation', ['request']),
  },
  watch: {
    id() {
      this.$store.commit('dkoCooperation/SET_REQUEST', null);
      this.$store.commit('dkoCooperation/SET_ACTIONS', []);
      this.load();
    },
  },
  created() {
    this.load();
  },
  beforeDestroy() {
    this.$store.commit('dkoCooperation/SET_REQUEST', null);
    this.$store.commit('dkoCooperation/SET_ACTIONS', []);
  },
  methods: {
    ...mapActions('dkoCooperation', ['fetchOne', 'fetchActions', 'deleteMember']),
    ...mapActions('dialog', ['showDialog']),
    load() {
      const requestId = this.id;
      this.fetchOne(requestId).then(() => {
        if (String(this.id) === String(requestId)) {
          return this.fetchActions(requestId);
        }
        return null;
      });
    },
    openTeam(listType) {
      const titles = {
        members: 'zespół projektowy',
        orderers: 'zespół zlecający',
        managers: 'zespół decyzyjny',
      };
      this.showDialog({
        header: 'Dodaj osobę',
        text: `Dodajesz osobę do listy: ${titles[listType]}.`,
        component: 'AddDkoTeamMember',
        props: { listType, width: 480 },
      });
    },
    removeMember(id, listType) {
      this.deleteMember({ id, listType });
    },
  },
};
</script>
